module.exports = __webpack_public_path__ + "static/media/craftIrish.983cb318.jpeg";